export default axios => ({
  getList () {
    return axios.get('/department')
  },
  getItem (id) {
    return axios.get(`/department/${id}`)
  },
  update (id, payload) {
    return axios.patch(`/department/${id}`, payload)
  },
  delete (id) {
    return axios.delete(`/department/${id}`)
  },
  create (payload) {
    return axios.post('/department', payload)
  }
})
